import ContentPageLayout from 'components/ContentPageLayout'

const Privacy = (): JSX.Element => {
	return <ContentPageLayout contentKey="privacy" />
}

export default Privacy
